import { FC } from 'react';
import styles from './ButtonSave.module.scss';
import classNames from 'classnames';
import { useSaveCardWorker } from 'hooks/useSaveCardWorker';

interface buttonType {
  button_draft: string;
  button_disabled: string;
}

const themes: buttonType = {
  button_draft: styles.button_draft,
  button_disabled: styles.button_disabled,
};
interface ButtonSaveTypes {
  draft?: boolean;
  onClick: (a: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  theme?: keyof typeof themes;
  text?: string;
}

export const ButtonSave: FC<ButtonSaveTypes> = ({
  onClick,
  disabled = true,
  theme,
  text,
}) => {
  const { isLoading } = useSaveCardWorker();

  return (
    <div className={styles.container}>
      <button
        disabled={!disabled}
        onClick={onClick}
        className={classNames(styles.button, theme ? themes[theme] : null)}>
        {isLoading ? 'Сохраняем...' : text}
      </button>
    </div>
  );
};
